import { FIELD_EMAIL, FIELD_PARTICIPATION_TYPE } from "../constants";

function filterFilledRegistrationFields(requiredFields, registrationField) {
    return registrationField.filter(({name}) => {
        return requiredFields.includes(name)
            || name === FIELD_EMAIL
            || name === FIELD_PARTICIPATION_TYPE;
    });
}

export default filterFilledRegistrationFields;
